var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListForSale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.3939 16 16 12.3881 16 7.99621C16 3.61193 12.3864 0 8 0C3.60606 0 0 3.61193 0 7.99621C0 12.3881 3.61364 16 8 16ZM8 14.0085C4.67424 14.0085 2 11.328 2 7.99621C2 4.67203 4.66667 1.99148 8 1.99148C11.3258 1.99148 14.0076 4.67203 14.0076 7.99621C14.0152 11.328 11.3333 14.0085 8 14.0085ZM8 11.8807C8.48485 11.8807 8.85606 11.5476 8.85606 11.0781V7.86749L8.76515 6.38334L9.33333 7.14813L10.0909 7.9735C10.2197 8.13251 10.4242 8.21581 10.6364 8.21581C11.0682 8.21581 11.3788 7.92049 11.3788 7.50402C11.3788 7.27686 11.3182 7.11784 11.1515 6.94368L8.69697 4.39186C8.50758 4.17984 8.2803 4.07383 8 4.07383C7.72727 4.07383 7.50758 4.17984 7.31061 4.39186L4.84848 6.94368C4.68939 7.11784 4.62879 7.27686 4.62879 7.50402C4.62879 7.92049 4.93182 8.21581 5.36364 8.21581C5.58333 8.21581 5.78788 8.12494 5.91667 7.9735L6.68182 7.13299L7.23485 6.38334L7.15152 7.86749V11.0781C7.15152 11.5476 7.52273 11.8807 8 11.8807Z",
    fill: "#21FFEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListForSale);
export default __webpack_public_path__ + "static/media/list-for-sale.11fc98c7fe266dd4eeea39565565cc29.svg";
export { ForwardRef as ReactComponent };